import { v4 as uuidv4 } from 'uuid';

import { MobileIssueSectionContainer } from 'data/generated/graphql';
import { AllessehSummariesResponse } from 'hooks/useAllessehCollectionSummariesQuery';

export function normalizeCollectionIdInput(fullInput: string, previousValue: string, prefix: string): string {
  const prevLength = previousValue.length;
  const nextLength = fullInput.length;
  const typedOneChar = nextLength === prevLength + 1;

  let suffix: string;

  if (typedOneChar && !fullInput.startsWith(prefix)) {
    suffix = fullInput.slice(prefix.length + 1);
  } else {
    suffix = fullInput.slice(prefix.length);
  }

  const cleanedSuffix = suffix.replace(/[^a-zA-Z0-9_-]/g, '');
  return (prefix + cleanedSuffix).toUpperCase();
}

export function convertSummariesToSectionData(summary: AllessehSummariesResponse): MobileIssueSectionContainer {
  return {
    allessehId: summary.data.id,
    baseDocId: summary.data.id,
    status: summary.data.attributes.status,
    subtype: 'MobileIssueModule',
    type: 'Issue',
    uuid: uuidv4(),
    attributes: {
      sectionLabel: summary.data.attributes.parameters?.find((param) => param.name === 'section_label')?.value ?? ''
    },
    collection: []
  };
}
